import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { getConfigurations } from "../../../apis/ConfigurationsApi.js";
import getConfigurationsColumns from "../../../const/columns/ConfigurationsCampaignColumns.js";

const Configurations = () => {
  const [configurations, setConfigurations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfigurations();
  }, []);

  const fetchConfigurations = async () => {
    try {
      const res = await getConfigurations();
      setConfigurations(res.result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Configurations:", error);
      setLoading(false);
    }
  };

  //   const deleteConfigurations = async (id) => {
  //     const isConfirmed = window.confirm(
  //       "Are you sure you want to delete this Document?"
  //     );
  //     if (isConfirmed) {
  //       const res = await deleteConfigurations(id);
  //       console.log(res, ":w6w96w96829w6982968w986");
  //       fetchConfigurations();
  //     }
  //   };
  const columns = getConfigurationsColumns();

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* <Link to="/AddDocuments" className="btn btn-primary mb-3">
              Add Documents
            </Link> */}
            {loading ? (
              <div>Loading...</div>
            ) : (
              <Table
                columns={columns}
                dataSource={configurations?.length > 0 ? configurations : []}
                className="table-striped"
                rowKey={(record) => record.id}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Configurations;
